import {StandardSchemaV1} from '@standard-schema/spec';
import {brand, Branded, string} from 'io-ts';
import {NonEmptyString} from '../NonEmptyString';

export type BaseCurrencyCode = StandardSchemaV1.InferOutput<typeof BaseCurrencyCode>;
export const BaseCurrencyCode = brand(
    string,
    (n): n is Branded<NonEmptyString, {readonly BaseCurrencyCode: unique symbol}> => n.length > 1,
    'BaseCurrencyCode'
);
